import styled from "styled-components";

export const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border: 1px solid #eef2f5;
  border-radius: 8px;
  padding: 10px 14px;
  margin-top: 15px;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
`;

export const ScrollArea = styled.div`
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  flex: 1;
  padding: 4px 0;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export const ArrowButton = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 5px rgba(0,0,0,0.06);
  transition: all 0.2s;
  
  &:hover {
    border-color: ${props => props.color || "#1FBA30"};
    background: #fafafa;
    transform: scale(1.05);
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    &:hover {
      border-color: #e2e8f0;
      transform: none;
    }
  }

  svg {
    width: 14px;
    height: 14px;
    fill: ${props => props.disabled ? "#94a3b8" : (props.color || "#1FBA30")};
  }
`;

export const DateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 65px;
  height: 65px;
  border-radius: 6px;
  cursor: pointer;
  background: ${props => props.active ? (props.activeColor || "#1FBA30") : "transparent"};
  border: 1.5px solid ${props => props.active ? (props.activeColor || "#1FBA30") : "#f1f5f9"};
  transition: all 0.25s ease;
  user-select: none;
  
  &:hover {
    border-color: ${props => props.active ? (props.activeColor || "#1FBA30") : (props.activeColor || "#1FBA30")};
    background: ${props => props.active ? (props.activeColor || "#1FBA30") : "#f8fafc"};
    transform: translateY(-2px);
  }
  
  .day-name {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: ${props => props.active ? "#ffffff" : "#64748b"};
    margin-bottom: 2px;
  }
  
  .day-number {
    font-size: 16px;
    font-weight: 800;
    color: ${props => props.active ? "#ffffff" : "#1e293b"};
  }
`;
